import BaseComponent from "@js/components/base_component.jsx";

import EuiSendingDomainsForm from "@js/components/eui/sending_domains/form.jsx";

class EuiSendingDomainsShow extends BaseComponent {

  render() {
    return (
      <EuiSendingDomainsForm { ...this.props } editing={ false } />
    );
  }

}

export default EuiSendingDomainsShow;
